/* media-gallery-black.js
   Springt beim Variantenwechsel zum ersten Bild der gewählten Variante.
   Alle Bilder aller Varianten sind gleichzeitig in der Galerie.
*/
if (!customElements.get('bb-gallery')) {
  class BBGallery extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.js-product') || this.closest('.shopify-section');
      if (this.section) {
        this.onVariant = this.onVariantChange.bind(this);
        this.section.addEventListener('on:variant:change', this.onVariant);
      }
    }

    disconnectedCallback() {
      if (this.section && this.onVariant) {
        this.section.removeEventListener('on:variant:change', this.onVariant);
      }
    }

    onVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      const target = this.querySelector(`[data-bb-variant="${variant.id}"]`);
      if (!target) return;

      const viewer = this.querySelector('.media-viewer');
      if (!viewer) return;

      viewer.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });

      const idx = target.dataset.mediaId;
      const thumbs = this.querySelectorAll('.media-thumbs__item');
      thumbs.forEach((t) => {
        const btn = t.querySelector('.media-thumbs__btn');
        if (!btn) return;
        if (t.dataset.mediaId === idx) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.removeAttribute('aria-current');
        }
      });
    }
  }
  customElements.define('bb-gallery', BBGallery);
}